import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import * as React from 'react';
import { DEFAULT_RECOMMENDATION_TIME } from '../constants/time';
import { ValidationError } from '../utils/errors';
import { formatPhone, prepareCallbackParams } from '../utils/formatters';
import { getCallTimeString } from '../utils/messages';
import { getNextHour } from '../utils/time';
import { validateForm } from '../utils/validators/validateForm';
export var useCallbackForm = function useCallbackForm(_ref) {
  var agentPhone = _ref.agentPhone,
    defaultRecommendationsEnabled = _ref.defaultRecommendationsEnabled,
    onRecommendationsChange = _ref.onRecommendationsChange,
    onRequestCallback = _ref.onRequestCallback,
    recommendations = _ref.recommendations,
    recommendationTime = _ref.recommendationTime,
    timezoneDiff = _ref.timezoneDiff,
    userPhoneNumber = _ref.userPhoneNumber,
    workTime = _ref.workTime;
  var _React$useState = React.useState(''),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    phone = _React$useState2[0],
    setPhone = _React$useState2[1];
  var _React$useState3 = React.useState(''),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    time = _React$useState4[0],
    setTime = _React$useState4[1];
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    isUserConfirmed = _React$useState6[0],
    setIsUserConfirmed = _React$useState6[1];
  var _React$useState7 = React.useState(false),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    withRecommendations = _React$useState8[0],
    setWithRecommendations = _React$useState8[1];
  var _React$useState9 = React.useState(false),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    isSubmitting = _React$useState10[0],
    setIsSubmitting = _React$useState10[1];
  var _React$useState11 = React.useState({}),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    errors = _React$useState12[0],
    setErrors = _React$useState12[1];
  var firstFieldRef = React.useRef(null);
  var hasRecommendations = !!recommendations && recommendations.length > 0;
  var handlePhoneChange = React.useCallback(function (value) {
    setPhone(value);
    setErrors(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        phone: undefined
      });
    });
  }, []);
  var handleTimeChange = React.useCallback(function (value) {
    setTime(value);
    setErrors(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        time: undefined
      });
    });
  }, []);
  var handleWithRecommendationsChange = React.useCallback(function (value) {
    setWithRecommendations(value);
    if (onRecommendationsChange) {
      onRecommendationsChange(value);
    }
  }, [onRecommendationsChange]);
  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
      var formValues, requestParams;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            event.preventDefault();
            if (!isSubmitting) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return");
          case 3:
            _context.prev = 3;
            setIsSubmitting(true);
            formValues = {
              agentPhone: agentPhone,
              phone: phone,
              time: time,
              withRecommendations: withRecommendations
            };
            validateForm(formValues, {
              timezoneDiff: timezoneDiff,
              workTime: workTime
            });
            requestParams = prepareCallbackParams(formValues, {
              recommendationTime: recommendationTime !== null && recommendationTime !== void 0 ? recommendationTime : DEFAULT_RECOMMENDATION_TIME,
              recommendations: recommendations || [],
              timezoneDiff: timezoneDiff
            });
            _context.next = 10;
            return onRequestCallback(requestParams);
          case 10:
            _context.next = 15;
            break;
          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](3);
            if (_context.t0 instanceof ValidationError) {
              setErrors({
                phone: _context.t0.errors.customerPhone,
                time: _context.t0.errors.time
              });
            }
          case 15:
            _context.prev = 15;
            setIsSubmitting(false);
            return _context.finish(15);
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 12, 15, 18]]);
    }));
    return function handleSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var initializeForm = function initializeForm() {
    setIsSubmitting(false);
    setIsUserConfirmed(false);
    setErrors({});
    setPhone(userPhoneNumber ? formatPhone(userPhoneNumber) : '');
    setTime(getNextHour());
    setWithRecommendations(Boolean(hasRecommendations && defaultRecommendationsEnabled));
  };
  React.useEffect(function () {
    initializeForm();
    setTimeout(function () {
      if (firstFieldRef.current) {
        firstFieldRef.current.focus();
      }
    }, 0);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var callTime = getCallTimeString(workTime, timezoneDiff);
  var isSubmitDisabled = !isUserConfirmed;
  var values = {
    isUserConfirmed: isUserConfirmed,
    phone: phone,
    time: time,
    withRecommendations: withRecommendations
  };
  return {
    callTime: callTime,
    errors: errors,
    firstFieldRef: firstFieldRef,
    handlePhoneChange: handlePhoneChange,
    handleSubmit: handleSubmit,
    handleTimeChange: handleTimeChange,
    handleUserConfirmedChange: setIsUserConfirmed,
    handleWithRecommendationsChange: handleWithRecommendationsChange,
    isSubmitDisabled: isSubmitDisabled,
    isSubmitting: isSubmitting,
    values: values
  };
};